import React from 'react';
import MainCategories from '../Layouts/MainCategories';
import MainJobs from '../Layouts/MainJobs';
import MainSlider from '../Layouts/MainSlider';
import MainRegisterSection from '../Layouts/MainRegisterSection';
import { isCompany } from '../../Config/isCompany';
import MyPosts from '../Company/MyPosts';
import { isUser } from '../../Config/isUser';

const MainDuyuru = () => {


  return (
    <div>
      {isCompany ? <MyPosts /> : <MainSlider />}

      {!isCompany && <MainCategories />}

      {!isCompany && !isUser && <MainRegisterSection />}

      {!isCompany && <MainJobs />}
    </div>
  );
};

export default MainDuyuru;
